import React from 'react';
import { Box, Container, Typography, Button, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { theme } from '../../theme/theme';
import PageWithHeader from '../common/PageWithHeader';
import { Link } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Helmet } from 'react-helmet-async';

const useStyles = makeStyles({
  root: {
    padding: theme.spacing(4),
    backgroundColor: '#f8f9fa',
    minHeight: 'calc(100vh - 90px)',
  },
  container: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  paper: {
    padding: theme.spacing(6),
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    backgroundColor: '#fff',
    maxWidth: '600px',
    width: '100%',
  },
  icon: {
    fontSize: '80px',
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
  header: {
    fontWeight: 700,
    color: '#2c3e50',
    marginBottom: theme.spacing(2),
  },
  subheader: {
    color: '#7f8c8d',
    marginBottom: theme.spacing(4),
  },
  button: {
    marginTop: theme.spacing(2),
    textTransform: 'none',
    fontWeight: 600,
    padding: '10px 24px',
  },
});

const NotFound: React.FC = () => {
  const classes = useStyles();

  return (
    <PageWithHeader>
      <Helmet>
        <title>Page Not Found | WestProp Residents Portal</title>
        <meta name="description" content="The page you are looking for does not exist" />
      </Helmet>
      <Box className={classes.root}>
        <Container maxWidth="md" className={classes.container}>
          <Paper className={classes.paper} elevation={0}>
            <ErrorOutlineIcon className={classes.icon} />
            <Typography variant="h1" className={classes.header}>
              404 - Page Not Found
            </Typography>
            <Typography variant="body1" className={classes.subheader}>
              The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
            </Typography>
            <Button
              component={Link}
              to="/"
              variant="contained"
              color="primary"
              className={classes.button}
            >
              Return to Dashboard
            </Button>
          </Paper>
        </Container>
      </Box>
    </PageWithHeader>
  );
};

export default NotFound;